'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _atSigns = require('./atSigns');

var _atSigns2 = _interopRequireDefault(_atSigns);

var _latinAccentChars = require('./latinAccentChars');

var _latinAccentChars2 = _interopRequireDefault(_latinAccentChars);

var _regexSupplant = require('../lib/regexSupplant');

var _regexSupplant2 = _interopRequireDefault(_regexSupplant);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var endMentionMatch = (0, _regexSupplant2.default)(/^(?:#{atSigns}|[#{latinAccentChars}]|:\/\/)/, { atSigns: _atSigns2.default, latinAccentChars: _latinAccentChars2.default }); // Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

exports.default = endMentionMatch;
module.exports = exports['default'];